export enum FailureType {
  Validation,
  General,
  API
}
